var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-con-ins-coure-102"},[(
      _vm.content
        ? _vm.content.content.content.type == 'iframe' ||
          _vm.content.content.content.type == 'youtube'
        : ''
    )?_c('div',{staticClass:"main-con-to-video",domProps:{"innerHTML":_vm._s(_vm.content.content.content.video)}}):(_vm.content ? _vm.content.content.content.type == 'upload' : '')?_c('div',{staticClass:"main-con-to-video"},[_c('video',{attrs:{"src":"videos/دقيقه فيها حل لمشكلتين قاتلين دلوقت ليك 👈🏻👉🏻ثانويه عامه❤️.mp4"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }